<div>
    <div
        #mybets
        id="mybets"
        class="mybets-column mybets-redesign"
        [ngClass]="{
            'not-authenticated': !isAuthenticated,
            'mybets-betcard-redesign': !isEditBetHistory() && myBetsUtilService.isBetCardRedesigned(),
            'epcot-enabled': isEpcotEnabled,
        }">
        @if (isAuthenticated) {
            <div class="header in-column">
                @if (!isEditBetHistory()) {
                    <ms-my-bets-navigation />
                } @else {
                    <ng-container [ngTemplateOutlet]="editBetsHeader"></ng-container>
                }
            </div>
            @if (isEditBetHistory()) {
                <ms-my-bets-edit-bet-history-list [myBetsListContext]="myBetsListContext"></ms-my-bets-edit-bet-history-list>
            } @else {
                <ng-container [ngTemplateOutlet]="myBetsList"></ng-container>
            }
        } @else {
            <ng-container [ngTemplateOutlet]="not_authenticated"></ng-container>
        }
    </div>
    <div class="event-view-column"><ng-content></ng-content></div>
</div>

<ng-template #myBetsList>
    @if (isInitalLoadReady) {
        @if (showBetSlipList) {
            <div class="help-container">
                @if (showArchivedBets) {
                    <ms-help-box-archived-bets class="help-archived" *ngIf="showArchivedBets"></ms-help-box-archived-bets>
                }
                @if (showTransactionBets) {
                    <ms-help-box-transaction-bets class="help-archived"></ms-help-box-transaction-bets>
                }
                @if (showReBetHelpBox) {
                    <ms-help-box-re-bet class="re-bet" [listType]="myBetsListContext.listType"></ms-help-box-re-bet>
                }
                @if (isAutoCashoutHelpBoxVisible) {
                    <ms-help-box
                        boxType="autocashout"
                        class="help-auto-cachout"
                        (closeButtonClick)="onAutoCashoutHelpBoxClose()"
                        (infoIconClick)="onAutoCashoutHelpInfoIconClick()"></ms-help-box>
                }
                @if (isShareMyBetHelpBoxVisible) {
                    <ms-help-box
                        class="help-share-my-bet"
                        [boxType]="betType.ShareMyBet"
                        (closeButtonClick)="onShareMyBetHelpBoxClose()"></ms-help-box>
                }
                @if (isCashOutInfoVisible) {
                    <ms-help-box
                        class="help-cashout-info"
                        [boxType]="betType.CashOutInfo"
                        (closeButtonClick)="onCashoutInfoHelpBoxClose()"></ms-help-box>
                }
            </div>

            <ms-my-bets-list
                [listType]="data.listType"
                [betslips]="data.betslips"
                [myBetsListContext]="myBetsListContext"
                [filterConstraint]="filterConstraint"
                [context]="context"
                [inColumn]="isShowMyBetsPopup() ? false : true"
                [ngClass]="{ 'cards-with-helpbox': isAutoCashoutHelpBoxVisible }"
                [earlyPayoutSubscription]="earlyPayoutService"
                [showMigrationTabs]="showMigrationTabs"
                (requestMore)="loadMoreBetSlips()"
                (filterChanged)="onFilterChanged()"
                (unpinningAnimate)="onBetUnpinned()">
            </ms-my-bets-list>
            @if (showMoreVisible) {
                @if (!showMoreClicked) {
                    <div class="show-more-btn-mini">
                        <button ds-button size="large" variant="flat-reduce" kind="tertiary" truncate="true" (click)="onShowMoreClick()">
                            {{ sitecoreMyBets.myBets.ShowMoreButton }}
                            <span slot="end">
                                <vn-icon size="14" name="theme-down" />
                            </span>
                        </button>
                    </div>
                }

                @if (showMoreClicked) {
                    <div class="show-more-loading-indicator">
                        <div class="loading"><span></span></div>
                    </div>
                }
            }
        } @else {
            <ng-container [ngTemplateOutlet]="empty_list"></ng-container>
        }

        <ms-stadium-my-bets [listType]="data.listType"></ms-stadium-my-bets>
    } @else {
        <ng-container [ngTemplateOutlet]="loading"></ng-container>
    }
    <div class="event-view-column"><ng-content></ng-content></div>
</ng-template>

<ng-template #not_authenticated>
    @if (!isEpcotEnabled) {
        <div class="mybets-not-authenticated" (click)="redirectHelperService.goToLogin()">
            <vn-icon class="mybets-not-authenticated-icon" size="12" name="theme-info-i" />
            <span [innerHTML]="sitecoreMyBets.myBets_NotLoggedIn?.text"></span>
        </div>
    }

    @if (isEpcotEnabled) {
        <div class="mybets-not-authenticated" (click)="redirectHelperService.goToLogin()">
            <ms-epcot-notification [message]="sitecoreMyBets.myBets_NotLoggedIn?.text" [notificationType]="'info'"></ms-epcot-notification>
        </div>
    }
</ng-template>

<ng-template #loading> <div class="mybets-empty popup-body"></div> </ng-template>

<ng-template #editBetsHeader> <ms-my-bets-edit-bet-history-header></ms-my-bets-edit-bet-history-header> </ng-template>

<ng-template #empty_list>
    <ms-my-bets-empty-list
        [listType]="data.listType"
        [filterConstraint]="filterConstraint"
        [inColumn]="true"
        [errorLoadingBets]="data.errorLoadingBets"
        [showMigrationTabs]="showMigrationTabs"
        [myBetsListContext]="myBetsListContext"
        (filterChanged)="onFilterChanged()"></ms-my-bets-empty-list>
</ng-template>
